function isPunjabi(text) {
	var pattern = /[\u0A05-\u0A06-\u0A07-\u0A08]/
	let result = pattern.test(text)
	return result
}

export default isPunjabi